import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "row justify q-pl-md" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "q-px-sm" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 1,
  class: "q-pa-md"
}
const _hoisted_7 = { class: "flex full-width q-pa-md q-pt-lg" }

import { ref, PropType, computed, onMounted } from 'vue';
    import { LoanApplication, HpPrice, PcpPrice } from "src/types/loan-application/index";
    import { QuoteSource_Enum, ContactType_Enum } from "src/types/enums/index";
    import { QuoteSendRequest } from "src/types/quote/index";
    import { Dialog, Notify, QSelect } from "quasar";
    import { useAuthStore } from "src/stores/auth-store";
    import { ProposalService, VehicleService } from "src/services";
    import CustomerDetailsForm from "src/components/form/forms/CustomerDetailsForm.vue";
    import { useMapChannelsToFlags } from 'src/functions/mappers/use-map-channels-to-flags';
    import { MessageRequest } from 'src/types/notification/message-request';
import { useWebSocketStore } from 'src/stores/websocket-store';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteSend',
  props: {
      modelValue: {
      type: Boolean,
      default: false
    },
    application: {
      type: Object as PropType<LoanApplication>,
      default: null
    },
    quote: {
      type: Object as PropType<HpPrice | PcpPrice>,
      default: null
    },
    source: {
      type: Number,
      default: QuoteSource_Enum.QuickQuote
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { emit: __emit }) {

    const authStore = useAuthStore();
    const wsStore = useWebSocketStore();

    const props = __props

  const value = computed<boolean>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return false
      }
    },
    set(value: boolean) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const smsSelected = ref(false);
  const emailSelected = ref(false);
  const whatsappSelected = ref(false);

  const affiliateUserId = ref<number | null>(authStore.affiliateUserId);

  const dealers = computed(() => authStore.selectedDealers ? authStore.selectedDealers.map(d => ({ label: d.name, value: d.affiliateUserId })) : []);

  const dealershipSelect = ref<QSelect | null>(null);

  const aidLocked = ref(false);
  
  onMounted(() => {
    if(props.application && props.application.affiliateUserId){
      affiliateUserId.value = Number(props.application.affiliateUserId);
      aidLocked.value = true;
    }
  })

  function sendAppToCustomer(){
    if(!props.application.customer || !props.application.customer.firstName || props.application.customer.firstName === "" ||
      !props.application.customer.lastName || props.application.customer.lastName === ""){
      Dialog.create({
        title: "Error",
        message: "Please provide a first and last name"
      })
      return;
    }

    if(!emailSelected.value && !smsSelected.value && !whatsappSelected.value){
      Dialog.create({
        title: "Error",
        message: "Please select at least one communication channel"
      })
      return;
    }
    if(emailSelected.value && !props.application.customer!.email){
      Dialog.create({
        title: "Error",
        message: "Please provide an email address"
      })
      return;
    }
    if((smsSelected.value || whatsappSelected.value) && !props.application.customer!.contactNumber){
      Dialog.create({
        title: "Error",
        message: "Please provide a mobile number"
      })
      return;
    }
    if(affiliateUserId.value === null){
      Dialog.create({
        title: "Error",
        message: "Please select a dealership"
      })
      return;
    }

    send();

    value.value = false;
  }

  async function send() {
    if (!props.quote && props.source === QuoteSource_Enum.QuickQuote) {
      return;
    }
    
    try {

      let img = props.source === QuoteSource_Enum.StockFeed ? props.application.vehicle.image : null;
      if (!img && props.application.vehicle.vehicleId) {
        const res = await VehicleService.vehicleLookup(props.application.vehicle.vehicleRegistration);
        if (res && res.image) {
          img = res.image.replace("q_10", "q_80");
        }
      }

      const request = {
        affiliateUserId: Number(affiliateUserId.value!),
        vehicleId: props.application.vehicle.vehicleId ?? 0,
        quickQuoteId: props.application.quickQuoteId,
        vehicleImage: img,
        firstName: props.application.customer!.firstName,
        surname: props.application.customer!.lastName,
        dealer: !authStore.selectedDealers ? authStore.dealerName : authStore.selectedDealers.find(d => d.affiliateUserId === affiliateUserId.value)?.name,
        vrm: props.application.vehicle.vehicleRegistration,
        make: props.application.vehicle.make,
        model: props.application.vehicle.model,
        mileage: props.application.vehicle.mileage,
        registrationDate: props.application.vehicle.registrationDate,
        fuelType: props.application.vehicle.fuel,
        transmission: props.application.vehicle.transmission,
        price: props.application.vehicle.price,
        deposit: props.application.deposit,
        pxValue: props.application.pxValue,
        pxSettlement: props.application.settlement,
        btf: props.quote ? props.quote.amountToFinance : props.application.vehicle.price,
        lender: props.quote ? props.quote.financeCompany : "Car Finance 247",
        term: props.quote ? props.quote.term : 60,
        apr: props.quote ? props.quote.effectiveRate ?? props.quote.apr : 0,
        monthlyPayment: props.quote ? props.quote.monthlyPayment : 0,
        optionToPurchase: props.quote ? props.quote.lendersPostFees : 0,
        costOfCredit: props.quote ? props.quote.costOfCredit : 0,
        optionalFinalPayment: props.quote ? props.quote.finalPayment : 0,
        amountPayable: props.quote ? props.quote.totalAmountPayable : 0,
        productType: props.quote ? props.quote.isPCP ? 1 : 0 : 0,
        email: props.application.customer ? props.application.customer.email : "",
        contactNumber: props.application.customer ? props.application.customer.contactNumber : "",
        annualMileage: props.application.vehicle.annualMileage,
        includeFinanceDetails: props.source !== QuoteSource_Enum.StockFeed ? true : false,
        includeApplyLink: true
      } as QuoteSendRequest;

      const channels = [] as ContactType_Enum[];

      emailSelected.value ? channels.push(ContactType_Enum.Email) : null;
      smsSelected.value ? channels.push(ContactType_Enum.Text) : null;
      whatsappSelected.value ? channels.push(ContactType_Enum.WhatsApp) : null;

      const contactTypes = [] as ContactType_Enum[];
      if (emailSelected.value) {
          contactTypes.push(ContactType_Enum.Email);
      }
      if (smsSelected.value) {
          contactTypes.push(ContactType_Enum.Text);
      }
      if (whatsappSelected.value) {
          contactTypes.push(ContactType_Enum.WhatsApp);
      }

      const channel = useMapChannelsToFlags(channels);

      const message: MessageRequest = {
          scenario: 'Customer_Quote',
          data: {
            ...request,
            channel,
          }
      };
      
      await wsStore.sendScenarioMessage(message, affiliateUserId.value!.toString()).catch(err => {
          throw new Error(err.message);
      });

      Notify.create({
        message: "Quote sent to customer via selected channels",
        color: "positive",
        position: "top"
      })

      return true;
    }
    catch(error){

      Notify.create({
        message: "Issue sending quote. Please try again.",
        color: "negative",
        position: "top"
      })

      return false;
    }
    

  }

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_DialogContainer = _resolveComponent("DialogContainer")!

  return (_openBlock(), _createBlock(_component_DialogContainer, {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((value).value = $event)),
    title: __props.source === _unref(QuoteSource_Enum).QuickQuote ? `Send application to ${__props.application.customer!.firstName} ${__props.application.customer!.lastName}` : 'Send application to customer',
    "full-height": false,
    maximized: false,
    close: true
  }, {
    default: _withCtx(() => [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "q-px-md q-pt-md text-body1 text-dark" }, " A personalised apply link will be sent to the customer. ", -1)),
      (__props.application.customer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(CustomerDetailsForm, {
              modelValue: __props.application.customer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.application.customer) = $event)),
              showTitle: false,
              firstName: __props.source === _unref(QuoteSource_Enum).StockFeed,
              surname: __props.source === _unref(QuoteSource_Enum).StockFeed,
              email: "",
              mobileNumber: "",
              ref: "customerDetailsForm"
            }, null, 8, ["modelValue", "firstName", "surname"])
          ]))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-overline text-uppercase q-mt-xs q-mb-xs q-pl-md" }, "Please select one or more communication channels", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_checkbox, {
            modelValue: emailSelected.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailSelected).value = $event)),
            class: "text-body2 text-dark",
            label: "Email",
            "icon-right": "mdi-email-outline"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_checkbox, {
            modelValue: smsSelected.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((smsSelected).value = $event)),
            class: "text-body2 text-dark",
            label: "SMS",
            "icon-right": "mdi-message-reply-text-outline"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_checkbox, {
            modelValue: whatsappSelected.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((whatsappSelected).value = $event)),
            class: "text-body2 text-dark",
            label: "WhatsApp",
            "icon-right": "mdi-whatsapp"
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_unref(authStore).selectedDealers && _unref(authStore).selectedDealers.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-overline text-uppercase text-dark q-mb-xs" }, "Dealership", -1)),
            _createVNode(_unref(QSelect), {
              modelValue: affiliateUserId.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((affiliateUserId).value = $event)),
              modelModifiers: { number: true },
              options: dealers.value,
              ref_key: "dealershipSelect",
              ref: dealershipSelect,
              rules: [val => (!!val) || 'Required'],
              "emit-value": "",
              "bg-color": "white",
              "popup-content-class": "text-body2",
              "map-options": "",
              placeholder: "Select a dealership",
              "data-cy": "dealershipSelect",
              outlined: "",
              dense: "",
              disable: aidLocked.value
            }, null, 8, ["modelValue", "options", "rules", "disable"])
          ]))
        : _createCommentVNode("", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_btn, {
          label: "Send",
          class: "brand-button",
          color: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (sendAppToCustomer()))
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})